import { Injectable } from '@angular/core';
import { ListMetadata } from 'app/models/list-metadata.model';
import { Observable } from 'rxjs';
import { HttpClientService } from '../httpClient/httpclient.service';
import { JsonSchema, JsonSchemaFormPropertiesForm, AuditRuleObject } from 'app/views/audit/models/audit-event.model';

@Injectable()
export class RulesDtlService {

  ruleId: number;
  baseUrl = '/k7o/event';

  constructor(private http: HttpClientService) { }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, 100, search, globalSearch, sort, sort_dir);
    if(this.ruleId && this.ruleId > 0){
      return this.http.getPaged(this.baseUrl + '/audit_rule/' + this.ruleId + '/audit_rule_dtl' +
        (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
    }
    return Observable.of({ data: [], metadata: { total: 0 } as ListMetadata });
  }

  deleteAuditRuleDtl(auditRuleDtlId: number){
    return this.http.delete(this.baseUrl + "/audit_rule_dtl/" + auditRuleDtlId);

  }
}



// WEBPACK FOOTER //
// ./src/app/services/audit/rulesdtl.service.ts